module.exports = __webpack_public_path__ + "img/coping_and_living.69bd81d7.png";